<template lang="pug">
  table#tbTanquesLlegando.table.is-striped.is-responsive
    thead
      tr
        th #
        th Embarque
        th Usuario
        th Fecha
        th Motivo
        th Cambios
    tbody
      tr(v-for="(c, index) in cambios" :key="c.id_cambio")
        td
          span.tag.is-black {{ index + 1 }}
        td
          span.tag.is-light {{ c.embarque_cambio ? c.embarque_cambio : 'No aplica' }}
        td
          span.tag.is-dark {{ c.usuario_cambio }}
        td
          span.tag {{ c.fecha_cambio }}
        td
          span.tag {{ c.motivo }}
        td.is-size-7 {{ c.cambios }}
</template>

<script>
  export default {
    name: 'Tb_Cambios',
    props: {
      cambios: {
        type: Array,
        default: [],
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/Tb_Cambios.vue